
import React from 'react';

import { IUserInfo } from '../../../../ts/models/IUserInfo';
import { DetailsTooltipStyles } from '../../CardView/DetailsTooltipStyles';
import { SpacesSiteUrls } from '../../SpacesSiteUrls';
import { HiddenUserStyles } from '../../SpacesStyles';

export interface UserProps {
  label?: string;
  user: IUserInfo;
  urls: SpacesSiteUrls;
}

interface UserDisplayProps {
  displayName: string;
  url: string;
  displayAsText: boolean;
}

export interface HiddenUserProps {
  displayName: string;
}

export function HiddenUserDisplay(props: HiddenUserProps) {
  return (
    <span className={HiddenUserStyles.HiddenUserClassName}> { props.displayName } </span>
  );
}

function UserDisplay(props: UserDisplayProps) {
  if (props.displayAsText) {
    return (
      <HiddenUserDisplay displayName={props.displayName} />
    );
  } else {
    return (
      <a href={ props.url }>{ props.displayName }</a>
    );
  }
}

export function User(props: UserProps) {
  if (!props.user || !props.user.displayName) {
    return null;
  }

  if (!props.label) {
    return (
      <UserDisplay displayName={props.user.displayName}
        url={props.urls.userUrl(props.user.username, props.user.domainName)}
        displayAsText={props.user.isHiddenInternalUser} />
    );
  }

  return (
    <div className={DetailsTooltipStyles.MetadataSection}>
      <span className={DetailsTooltipStyles.MetadataTitle}>{ props.label }</span>
      <span className={DetailsTooltipStyles.MetadataValue}>
        <UserDisplay displayName={props.user.displayName}
                      url={props.urls.userUrl(props.user.username, props.user.domainName)}
                      displayAsText={props.user.isHiddenInternalUser} />
      </span>
    </div>
  );
}
